import {
    Button,
    Box,
    Circle,
    Grid,
    GridItem,
    HStack,
    InputLeftElement,
    Stack,
    Text,
  } from "@chakra-ui/react";
  import { Form, Formik, FormikHelpers } from "formik";
  import * as Yup from "yup";
  import { FormInputControl,  FormPasswordControl, } from "../../../components/forms";
  import { MaterialIcon } from "../../../components/shared/MaterialIcon";

  interface IProps {
    handleFormSubmit: ( firstName: string, lastName: string, email: string, password: string ) => Promise<void>;
  }

  const AuthRegisterDemoForm = ({ handleFormSubmit }: IProps) => {
    const AuthRegisterDemoFormSchema = Yup.object().shape({
      firstName: Yup.string().required("Required"),
      lastName: Yup.string().required("Required"),
      email: Yup.string().email("Invalid Email").required("Email is required"),
      password: Yup.string().min(8).required("Required"),
      passwordConfirmation: Yup.string().oneOf(
        [Yup.ref("password"), null],
        "Passwords must match"
      ),
    });

    const handleAuthRegisterDemoFormSubmit = async (
      values,
      actions: FormikHelpers<{
        firstName: string;
        lastName: string;
        email: string;
        password: string;
        passwordConfirmation: string;
      }>
    ) => {
      try {
        // Get the values from the form
        const firstName = values.firstName;
        const lastName = values.lastName;
        const email = values.email;
        const password = values.password;
        // const user : IUserProfile = {
        //   email: values.email,
        //   id: values.password,
        //   first_name: values.firstName,
        //   last_name: values.lastName,
        // };
        // Pass up logic
        await handleFormSubmit(firstName, lastName, email, password);
      } catch (error: any) {
        console.log("Error RegisterDemo:", error);
    if (error.key && error.key === "email") {
          actions.setFieldError(error.key, error.status);
        } else {
          actions.setStatus(error.status);
        }
      }
      actions.setSubmitting(false);
    };


    return (
      <Formik
        initialValues={{
          email: "",
          password: "",
          firstName: "",
          lastName: "",
          passwordConfirmation: "",
        }}
        validationSchema={AuthRegisterDemoFormSchema}
        onSubmit={(values, actions) => {
          handleAuthRegisterDemoFormSubmit(values, actions);
        }}
      >
        {({ isSubmitting, errors, status, values }) => {
          const isPasswordUppercase = /[A-Z]/.test(values.password); // eslint-disable-line
          const isPasswordLowercase = /[a-z]/.test(values.password); // eslint-disable-line
          const isPasswordNumber = /\d/.test(values.password); // eslint-disable-line
          const isPasswordSymbol =
            /[\^\$\*\.\[\]\{\}\(\)\?"!@#%&,\>\<':;|_~]/.test(values.password); // eslint-disable-line
          
          return (

          <Form>
            <Stack spacing={6}>
              <HStack spacing={3}>
                <Box flex={1}>
                  <FormInputControl
                    name="firstName"
                    label="First Name"
                    type=""
                  />
                </Box>
                <Box flex={1}>
                  <FormInputControl
                    name="lastName"
                    label="Last Name"
                    type=""
                  />
                </Box>
              </HStack>
              <Grid templateColumns="repeat(6, 1fr)" gap={{ base: 4, lg: 6 }}>
                <GridItem colSpan={6}>
                  <FormInputControl
                    name="email"
                    label="Email"
                    type="email"
                    autoComplete="email"
                    inputMode="email"
                    inputLeftElement={
                      <InputLeftElement
                        pointerEvents="none"
                        children={
                          <MaterialIcon
                            name="email"
                            fontSize="1.5rem"
                            variant="outline"
                            color="text.softer"
                          />
                        }
                      />
                    }
                  />
                </GridItem>
                <GridItem colSpan={6}>
                  <FormPasswordControl
                    name="password"
                    label="Password"
                    inputLeftElement={
                      <InputLeftElement
                        pointerEvents="none"
                        children={
                          <MaterialIcon
                            name="key"
                            fontSize="1.5rem"
                            variant="outline"
                            color="text.softer"
                          />
                        }
                      />
                    }
                  />
                </GridItem>
                <GridItem colSpan={6}>
                  <FormPasswordControl
                    name="passwordConfirmation"
                    label="Confirmation Password"
                    inputLeftElement={
                      <InputLeftElement
                        pointerEvents="none"
                        children={
                          <MaterialIcon
                            name="key"
                            fontSize="1.5rem"
                            variant="outline"
                            color="text.softer"
                          />
                        }
                      />
                    }
                  />
                </GridItem>
              </Grid>
              
              <Box>
                <Stack fontSize="sm" color="text.soft">
                  <Text>
                    Let's make sure we have a good password, please include:
                  </Text>

                  <Stack spacing={1}>
                    <HStack>
                      <Circle
                        bg={isPasswordUppercase ? "success" : "white"}
                        color={isPasswordUppercase ? "white" : "text.softer"}
                        p={0.5}
                      >
                        {isPasswordUppercase ? (
                          <MaterialIcon
                            name="done"
                            fontSize="1rem"
                            variant="outline"
                          />
                        ) : (
                          <MaterialIcon
                            name="close"
                            fontSize="1rem"
                            variant="outline"
                          />
                        )}
                      </Circle>
                      <Text>1 Uppercase</Text>
                    </HStack>
                    <HStack>
                      <Circle
                        bg={isPasswordLowercase ? "success" : "white"}
                        color={isPasswordLowercase ? "white" : "text.softer"}
                        p={0.5}
                      >
                        {isPasswordLowercase ? (
                          <MaterialIcon
                            name="done"
                            fontSize="1rem"
                            variant="outline"
                          />
                        ) : (
                          <MaterialIcon
                            name="close"
                            fontSize="1rem"
                            variant="outline"
                          />
                        )}
                      </Circle>
                      <Text>1 Lowercase</Text>
                    </HStack>
                    <HStack>
                      <Circle
                        bg={isPasswordSymbol ? "success" : "white"}
                        color={isPasswordSymbol ? "white" : "text.softer"}
                        p={0.5}
                      >
                        {isPasswordSymbol ? (
                          <MaterialIcon
                            name="done"
                            fontSize="1rem"
                            variant="outline"
                          />
                        ) : (
                          <MaterialIcon
                            name="close"
                            fontSize="1rem"
                            variant="outline"
                          />
                        )}
                      </Circle>
                      <Text>1 Symbol</Text>
                    </HStack>
                    <HStack>
                      <Circle
                        bg={isPasswordNumber ? "success" : "white"}
                        color={isPasswordNumber ? "white" : "text.softer"}
                        p={0.5}
                      >
                        {isPasswordNumber ? (
                          <MaterialIcon
                            name="done"
                            fontSize="1rem"
                            variant="outline"
                          />
                        ) : (
                          <MaterialIcon
                            name="close"
                            fontSize="1rem"
                            variant="outline"
                          />
                        )}
                      </Circle>
                      <Text>1 Number</Text>
                    </HStack>
                  </Stack>
                </Stack>
              </Box>

              <Button
                colorScheme="primary"
                type="submit"
                isDisabled={isSubmitting}
              >
                Create Account
              </Button>​
              {/* Display error */}
              {errors && status ? (
                <Text
                  textStyle="indicator"
                  mt={2}
                  color={"danger"}
                  id="password-error"
                >
                  {status}
                </Text>
              ) : null}
            </Stack>
          </Form>
          );
        }}
      </Formik>
    );
  };

  export default AuthRegisterDemoForm;